import { Permission } from '~/types/Permission';
import { testIsSuperAdmin } from '~/utils/user';

export const checkIsSuperAdmin: Permission = (user) => testIsSuperAdmin(user);
